<template>
    <div>
        <ul
            class="flex"
            data-spec-class="display-type_switch"
        >
            <li
                v-for="item in displayTypeItems"
                :key="item.type"
                :data-spec-class="`display-type_switch__${item.specClass}`"
                :class="{
                    'ml-3 border-b-2 transition duration-300 ease-in-out': true,
                    'border-primary text-primary': displayType === item.type,
                    'cursor-pointer border-none text-muted hover:border-primary hover:text-primary':
                        displayType !== item.type,
                }"
                @click="onSwitch(item.type)"
            >
                <component
                    :is="item.icon"
                    class="h-8 w-8"
                />
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { Squares2X2Icon, TableCellsIcon } from '@heroicons/vue/24/outline';
import { computed } from 'vue';
import { DisplayType } from '@/types';

interface Props {
    displayType?: DisplayType;
}

withDefaults(defineProps<Props>(), {
    displayType: DisplayType.Table,
});

const emits = defineEmits(['switch']);

const displayTypeItems = computed(() => [
    {
        type: DisplayType.Table,
        icon: TableCellsIcon,
        specClass: 'table',
    },
    {
        type: DisplayType.Grid,
        icon: Squares2X2Icon,
        specClass: 'grid',
    },
]);

const onSwitch = (key: string) => {
    emits('switch', key);
};
</script>
